import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6766653e = () => interopDefault(import('../pages/auth/login/index.vue' /* webpackChunkName: "pages/auth/login/index" */))
const _48662478 = () => interopDefault(import('../pages/auth/register/index.vue' /* webpackChunkName: "pages/auth/register/index" */))
const _adcd0e44 = () => interopDefault(import('../pages/users/mypage/index.vue' /* webpackChunkName: "pages/users/mypage/index" */))
const _1f930bfa = () => interopDefault(import('../pages/auth/register/error.vue' /* webpackChunkName: "pages/auth/register/error" */))
const _7dcce619 = () => interopDefault(import('../pages/auth/register/password.vue' /* webpackChunkName: "pages/auth/register/password" */))
const _d19b5808 = () => interopDefault(import('../pages/auth/reset/password/index.vue' /* webpackChunkName: "pages/auth/reset/password/index" */))
const _a1c35a96 = () => interopDefault(import('../pages/auth/register/verify/code.vue' /* webpackChunkName: "pages/auth/register/verify/code" */))
const _3245285e = () => interopDefault(import('../pages/users/redirect/oauth/email.vue' /* webpackChunkName: "pages/users/redirect/oauth/email" */))
const _28696178 = () => interopDefault(import('../pages/users/redirect/oauth/success.vue' /* webpackChunkName: "pages/users/redirect/oauth/success" */))
const _5599294c = () => interopDefault(import('../pages/users/redirect/oauth/success_complate.vue' /* webpackChunkName: "pages/users/redirect/oauth/success_complate" */))
const _56383829 = () => interopDefault(import('../pages/auth/reset/password/issue/code.vue' /* webpackChunkName: "pages/auth/reset/password/issue/code" */))
const _4e87a226 = () => interopDefault(import('../pages/auth/reset/password/verify/code.vue' /* webpackChunkName: "pages/auth/reset/password/verify/code" */))
const _1fcfa4b8 = () => interopDefault(import('../pages/users/redirect/oauth/verify/code.vue' /* webpackChunkName: "pages/users/redirect/oauth/verify/code" */))
const _487e60a9 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _44e437cb = () => interopDefault(import('../pages/users/question/:diagnosisId.vue' /* webpackChunkName: "pages/users/question/:diagnosisId" */))
const _56cd3238 = () => interopDefault(import('../pages/users/diagnoses/_diagnosisId/result/index.vue' /* webpackChunkName: "pages/users/diagnoses/_diagnosisId/result/index" */))
const _6217bfd3 = () => interopDefault(import('../pages/diagnoses/_diagnosisId/share/index.vue' /* webpackChunkName: "pages/diagnoses/_diagnosisId/share/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/discover_sexualities/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth/login",
    component: _6766653e,
    name: "auth-login"
  }, {
    path: "/auth/register",
    component: _48662478,
    name: "auth-register"
  }, {
    path: "/users/mypage",
    component: _adcd0e44,
    name: "users-mypage"
  }, {
    path: "/auth/register/error",
    component: _1f930bfa,
    name: "auth-register-error"
  }, {
    path: "/auth/register/password",
    component: _7dcce619,
    name: "auth-register-password"
  }, {
    path: "/auth/reset/password",
    component: _d19b5808,
    name: "auth-reset-password"
  }, {
    path: "/auth/register/verify/code",
    component: _a1c35a96,
    name: "auth-register-verify-code"
  }, {
    path: "/users/redirect/oauth/email",
    component: _3245285e,
    name: "users-redirect-oauth-email"
  }, {
    path: "/users/redirect/oauth/success",
    component: _28696178,
    name: "users-redirect-oauth-success"
  }, {
    path: "/users/redirect/oauth/success_complate",
    component: _5599294c,
    name: "users-redirect-oauth-success_complate"
  }, {
    path: "/auth/reset/password/issue/code",
    component: _56383829,
    name: "auth-reset-password-issue-code"
  }, {
    path: "/auth/reset/password/verify/code",
    component: _4e87a226,
    name: "auth-reset-password-verify-code"
  }, {
    path: "/users/redirect/oauth/verify/code",
    component: _1fcfa4b8,
    name: "users-redirect-oauth-verify-code"
  }, {
    path: "/",
    component: _487e60a9,
    name: "index"
  }, {
    path: "/users/question/:diagnosisId",
    component: _44e437cb,
    name: "users-question-:diagnosisId"
  }, {
    path: "/users/diagnoses/:diagnosisId?/result",
    component: _56cd3238,
    name: "users-diagnoses-diagnosisId-result"
  }, {
    path: "/diagnoses/:diagnosisId?/share",
    component: _6217bfd3,
    name: "diagnoses-diagnosisId-share"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
